import { createSlice } from "@reduxjs/toolkit";

const applicationsSlice = createSlice({
  name: "applications",
  initialState: [],
  reducers: {
    addApplication: (state, action) => {
      state.push(action.payload);
    },
    updateApplication: (state, action) => {
      const index = state.findIndex((app) => app.id === action.payload.id);
      if (index !== -1) state[index] = action.payload;
    },
    deleteApplication: (state, action) => {
      return state.filter((app) => app.id !== action.payload);
    },
  },
});

export const { addApplication, updateApplication, deleteApplication } = applicationsSlice.actions;
export default applicationsSlice.reducer;
